import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { Dynamic, type DynamicAction } from '@shared/registry/dynamic';

import type { SelectionRowConfig } from './selection-row.types';

@Component({
  selector: 'app-selection-row',
  templateUrl: './selection-row.html',
  imports: [Dynamic],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectionRow {
  readonly config = input.required<SelectionRowConfig>();
  readonly disabled = input<boolean>(false);

  readonly action = output<DynamicAction>();

  protected readonly labelTextConfig = computed(() => ({
    text: this.config().label,
    size: 'base' as const,
    fontWeight: 'semibold' as const,
    color: 'var(--selectionrow-content, var(--p-surface-900))',
  }));

  protected readonly buttonTextConfig = computed(() => ({
    text: this.config().buttonText ?? '',
    size: 'base' as const,
    fontWeight: 'bold' as const,
    color: 'var(--selectionrow-button, var(--p-surface-900))',
  }));

  protected onButtonClick(): void {
    const action = this.config().action;
    if (action) this.action.emit(action);
  }
}
